import React from "react";
import MobileAppAuthPinNumbersButton from "./MobileAppAuthPinNumbersButton";

function MobileAppAuthPinNumbersRow(props) {
    const {children, disabled, numList, onNumClick} = props;

    return <div className="d-flex justify-content-center">
        {
            children || numList.map(num =>
                <MobileAppAuthPinNumbersButton
                    disabled={disabled}
                    key={num}
                    onClick={onNumClick}
                    number={num}
                >
                    {num}
                </MobileAppAuthPinNumbersButton>)
        }
    </div>
}

export default MobileAppAuthPinNumbersRow;
